import React, { Component } from 'react';
import { Button, Col, Input, message, Row, Table } from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';

import { BackBtn } from '@comm/BackBtn';
import { queryBooksIncomeList, queryFinanceBooksStatistics } from '@api/finance/finance';
import getAllType from '@util/getAllType';
import CardStatic from './CardStatic';
import ModalProgress from './ModalProgress';

class FinanceCapitalDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNo: 1,
      record: [],
      condition: '',
      type: [],
      source: 'capital',
      progressVisible: false,
    };
  }

  componentWillMount() {
    getAllType().then(res => {
      this.setState({
        type: res,
      });
    });
    if (this.props.location.pathname.indexOf('statis') > 0) {
      this.setState({
        source: 'statis',
      });
    }
  }

  componentDidMount() {
    const { uuid } = this.props.params;

    this.loadStatistics(uuid);
    this.loadBooksIncomeList(1);
  }

  /**
   * 获取账号统计
   */
  loadStatistics = uuid => {
    queryFinanceBooksStatistics({ uuid }).then(res => {
      if (res.statusCode !== 200) {
        message.error(res.message);
      }
    });
  };

  /**
   * 获取流水记录列表
   */
  loadBooksIncomeList = pageNo => {
    const params = {};
    const { uuid } = this.props.params;
    params.bookUuid = uuid;
    params.condition = this.state.condition;
    const no = this.state.pageNo;
    const current = pageNo || no;
    params.limit = 15;
    params.start = current;
    this.setState({
      pageNo: current,
    });
    if (this.state.source === 'statis') {
      params.ignoreLevel = this.props.income_info.igNore;
      params.types = this.props.income_info.types;
      if (this.props.income_info.yearMonth) {
        params.yearMonth = this.props.income_info.yearMonth;
      } else if (this.props.income_info.date) {
        params.beginDate = moment(this.props.income_info.date[0]);
        params.endDate = moment(this.props.income_info.date[1]);
      }
    }
    queryBooksIncomeList(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          record: res.data,
        });
      }
    });
  };

  search = condition => {
    this.condition = condition;
    this.loadBooksIncomeList(1);
  };

  columns = () => {
    const { type } = this.state;
    return [
      {
        title: '付款单号',
        dataIndex: 'accountName',
        key: 'accountName',
        width: 200,
      },
      {
        title: '付款金额',
        dataIndex: 'remark',
        key: 'remark',
        width: 200,
      },
      {
        title: '申请人',
        dataIndex: 'type',
        key: 'type',
        width: 200,
        render: text => {
          let typeName = '';
          if (type.length > 0) {
            type.forEach(item => {
              if (text === item.value) {
                typeName = item.key;
                return typeName;
              }
            });
          }
          return <span>{typeName}</span>;
        },
      },
      {
        title: '申请日期',
        dataIndex: 'date',
        key: 'date',
        width: 200,
        render: (text, record) => (
          <a onClick={() => this.showModal(record.uuid)}>
            {moment.unix(text / 1000).format('YYYY-MM-DD')}
          </a>
        ),
      },
    ];
  };

  showModal = () => {};

  showImport = () => {};

  handleOk = () => {
    // this.refs.form.refs.wrappedComponent.refs.formWrappedComponent.submit()
  };

  handleCancel = () => {};

  handleSubmit = result => {
    if (result) {
      this.handleCancel();
      this.loadBooksIncomeList();
    }
  };

  setCondition = e => {
    this.setState({
      condition: e.target.value,
    });
  };

  showProgress = () => {
    this.setState({
      progressVisible: true,
    });
  };

  hideModal = () => {
    this.setState({
      progressVisible: false,
    });
  };

  render() {
    const { record } = this.state;
    const { progressVisible } = this.state;
    return (
      <div>
        <div className="payDetail">
          <div className="fixed-header">
            <Row type="flex" justify="space-between" style={{ marginBottom: '16px' }}>
              <Col>
                <BackBtn />
                <Button icon="left" onClick={this.showProgress}>
                  流程跟踪
                </Button>
              </Col>
              <Col style={{ textAlign: 'right' }}>
                <Input
                  placeholder="请输入关键字"
                  style={{ width: '300px' }}
                  value={this.state.condition}
                  onChange={this.setCondition}
                />
                <Button
                  type="primary"
                  style={{ marginLeft: '10px' }}
                  onClick={() => this.loadBooksIncomeList(1)}
                >
                  搜索
                </Button>
              </Col>
            </Row>
          </div>
          <CardStatic uuid={this.props.params.uuid} />
        </div>
        <Table
          columns={this.columns()}
          dataSource={record}
          pagination={false}
          rowKey="uuid"
          title={() => (
            <p style={{ textAlign: 'center', borderColor: '#e8e8e8' }}>
              杭州名轩花卉园艺有限公司过往记录
            </p>
          )}
        />
        {progressVisible ? <ModalProgress cancel={this.hideModal} /> : ''}
      </div>
    );
  }
}

export default connect(state => state)(FinanceCapitalDetail);



// WEBPACK FOOTER //
// ./src/components/finance/budget/check/PagePayDetail.js